import LottieView from "lottie-react-native";
import { View } from "react-native";
import { Text } from "react-native-paper";

import { Button, Modal } from "../../../components";

type Props = {
  onClose(): void;
  visible: boolean;
};

export default function SuccessModal({ onClose, visible }: Props) {
  const title = "Payment Request Sent";
  const description = "An email containing payment instructions and access to pay has been sent to your designated proxy.";

  return (
    <Modal visible={visible} onDismiss={onClose} title="">
      <View className="pt-12 items-center justify-between px-10 py-6 bg-sky-white" testID="ActivityReviewSuccessModal">
        <View className="items-center">
          <View className="w-28 h-28">
            <LottieView style={{ flex: 1 }} autoPlay source={require("../../../../assets/lottie-icons/bill.json")} />
          </View>
          <Text className="text-title-2 font-700 text-ink-darkest mt-8 text-center">{title}</Text>
          <Text className="text-regular-normal font-400 text-ink-dark my-6 px-4 text-center">{description}</Text>
        </View>

        <View className="w-full mb-4 mt-8">
          <Button mode="secondary" onPress={onClose}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
